export default [{
    path: 'qualification',
    component: () => import('@/views/organization/qualification/qualification.main'),
    children: [
        {
            name: 'qualificationList',
            path: 'list',
            components: {
                list: () => import('@/views/organization/qualification/qualification.list'),
            },
        },
        {
            name: 'qualificationDetail',
            path: 'detail',
            components: {
                detail: () => import('@/views/organization/qualification/qualification.detail'),
            },
        }
        ]
}]